import { FileSettings } from "$lib/commands/settings";
import { createDialog, createDialogButton, Vec2 } from "@ceyper-common";
import { COMMANDS } from "$lib/commands";
import { file as $file, interaction as $interaction } from "$lib/state";
import { File } from "$lib/wasm/file";
import { derived } from "svelte/store";
import { downloadFileAllFrames, downloadFileFrame } from "$lib/image/download";
import { notImplemented } from "$lib/commands/common";

const fileAvailable = derived($file, (file) => !!file);

export function registerFileCommands() {
    const { add, destroy } = COMMANDS.registerActions("all");
    add(
        "file.save",
        async (auto: boolean = false) => {
            const file = $file.value!;
            await file.save();
        },
        fileAvailable
    );

    add(
        "file.download",
        async () => {
            const file = $file.value!;

            const scale = FileSettings.value["file.export-scale"].value;
            const downloadAll = FileSettings.value["file.export-download-all"].value;

            if (downloadAll && file.getFrames().length > 1) {
                await downloadFileAllFrames(file, {
                    name: file.name,
                    scale,
                });
            } else {
                const frame = $interaction.value.frameIndex.value ?? 0;
                await downloadFileFrame(file, {
                    name: file.name,
                    scale,
                    frame,
                });
            }
        },
        fileAvailable
    );

    add(
        "file.download-as",
        async () => {
            const file = $file.value!;

            const result = await createDialog({
                id: "download-as",
                title: "Download as...",
                fields: {
                    name: {
                        name: "Name",
                        type: "string",
                        value: file.name,
                    },
                    scale: FileSettings.value["file.export-scale"],
                    allFrames: FileSettings.value["file.export-download-all"],
                },
                buttons: [createDialogButton.close("Cancel"), createDialogButton.confirm("Save")],
            });
            FileSettings.save();

            if (!result) return;

            if (result.allFrames && file.getFrames().length > 1) {
                await downloadFileAllFrames(file, result);
            } else {
                const frame = $interaction.value.frameIndex.value ?? 0;
                await downloadFileFrame(file, {
                    name: result.name,
                    scale: result.scale,
                    frame,
                });
            }
        },
        fileAvailable
    );

    add("file.new", async () => {
        const result = await createDialog({
            id: "new-file",
            title: "New file",
            fields: {
                name: {
                    name: "Name",
                    type: "string",
                    value: "Image",
                },
                width: {
                    name: "Width",
                    type: "number",
                    value: 32,
                },
                height: {
                    name: "Height",
                    type: "number",
                    value: 32,
                },
            },
            buttons: [createDialogButton.close("Cancel"), createDialogButton.confirm("Create")],
        });
        if (!result) return;

        const file = File.new(+result.width, +result.height, result.name);

        $file.set(file);
    });

    add("file.open", async () => {
        return notImplemented();

        // const result = await createDialog({
        //     id: "open-file",
        //     title: "Open file",
        //     fields: {
        //         name: {
        //             name: "Name",
        //             type: "string",
        //             value: "Image",
        //         },
        //         image: {
        //             name: "Image",
        //             type: "custom",
        //             component: ImageBrowser,
        //             props: {},
        //             value: null! as ImageData,
        //         },
        //     },
        //     buttons: [createDialogButton.close("Cancel"), createDialogButton.confirm("Open")],
        // });
        // if (!result) return;
        // if (!result.image) return;
        //
        // const data = result.image;
        //
        // const image = new EditorImage(result.name, Vec2.c(data.width, data.height));
        // image.setLayerData(image.layers[0], new Uint32Array(data.data.buffer));
        //
        // const animation = new EditorAnimation(result.name, [image]);
        //
        // activeAnimation.set(animation);
        // activeImage.set(animation.frames[0]);
        // activeAnimationFrame.set(0);
    });

    add("file.load", (file) => {
        $file.set(file);
    });

    add(
        "file.rename",
        async (name) => {
            const file = $file.value!;

            if (!name) {
                const result = await createDialog({
                    id: "rename-file",
                    title: "Rename file",
                    fields: {
                        name: {
                            name: "Name",
                            type: "string",
                            value: file.name,
                        },
                    },
                    buttons: [
                        createDialogButton.close("Cancel"),
                        createDialogButton.confirm("Rename"),
                    ],
                });
                name = result?.name;

                if (!name) return;
            }

            file.name = name;
            await file.save();
        },
        fileAvailable
    );

    add(
        "file.resize",
        async (width, height) => {
            return notImplemented();
        },
        false
    );

    add(
        "file.clear-history",
        async () => {
            const result = await createDialog({
                id: "clear-history",
                title: "Delete history",
                fields: {
                    info: {
                        name: "info",
                        type: "text",
                        value: "Deleting history is a non-reversible action, proceed with caution.",
                    },
                },
                buttons: [createDialogButton.close("Cancel"), createDialogButton.confirm("Delete")],
            });

            if (!result) return;

            const file = $file.value!;
            file.internal.clear_history();
        },
        fileAvailable
    );

    return { destroy };
}
